import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { DetailedSheetPage } from '../../../../../../../components/pages/backoffice/detailed-sheet-page/detailed-sheet-page.tsx'
import { PermissionChecker } from '../../../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId')({
  component: function Component() {
    const { subscriptionId, versionId } = Route.useParams()
    return (
      <PermissionChecker
        requiredPermissions={[
          anyOfPermissions('contract.read', 'contract.read.relatedOnly', 'contract.read.allowedOnly'),
        ]}
      >
        <DetailedSheetPage subscriptionId={subscriptionId} versionId={versionId} endorsementId={undefined} />
      </PermissionChecker>
    )
  },
})
